import { DialogBox } from "lib/@components/dialogBox"
import { Typography } from "@mui/material"
import { useState } from "react"
import { AuthoringEditor } from "authoring/components/authoring-editor"

export function ReturnToEditingDialog() {
    const [reason, setReason] = useState("")

    return (
        <DialogBox
            title="Return to Editing"
            okCaption="Return to Editing"
            okColor="warning"
            value={{
                reason: reason.trim(),
            }}
            data-cy="return-to-editing-dialog"
        >
            <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                Returning this schedule to editing will revoke its approval. The schedule will need to be re-submitted
                and re-reviewed before it can be approved again.
            </Typography>
            <AuthoringEditor
                value={reason}
                onChange={setReason}
                autoFocus
                label="Reason for Returning (Optional)"
                placeholder="Add a reason for returning this schedule to editing..."
                workplaceMaxHeight={240}
            />
        </DialogBox>
    )
}
